var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RightBadge',{attrs:{"color":"orange","title":"监理单位管理人员"}}),_c('RightBadge',{attrs:{"color":"blue","title":"施工单位管理人员"}}),_c('RightBadge',{attrs:{"color":"red","title":"施工单位安全员"}}),_c('RightBadge',{attrs:{"color":"green","title":"施工单位作业人员"}}),_c('RightBadge',{attrs:{"color":"pink","title":"作业的危险源"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }